type TAuth = {
	username: string;
	password: string;
	authEndpoint: string;
};

export const fetchAuth = async ({ username, password, authEndpoint }: TAuth) => {
	try {
		const API = import.meta.env.VITE_API_BASE_URL;

		const formData = new FormData();
		formData.append('username', username);
		formData.append('password', password);

		if (authEndpoint === '/admin-auth') {
			const url = `${API}/auth`;

			const response = await fetch(url, {
				method: 'POST',
				body: formData,
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const data = await response.json();

			return data;
		}

		formData.append('method', 'auth');

		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
	}
};
